<template>
  <div>
    <vx-card>
      <Form ref="form" @submitedData="submitedData" />

      <br />
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Form from "./form.vue";

export default {
  props: ["id"],
  components: {
    Form,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  mounted() {
    if (!this.id) {
      return this.$router.push("/warehouse/materialout/manual");
    }
    console.log(this.id);
    this.$refs.form.setFormValue(this.id);
  },
  methods: {
    async submitedData(data) {
      try {
        this.loadingWait();
        let post = await this.$api.post(
          "api/v1/warehouse/materialout/manual",
          data
        );
        if (post.data.status == "validation") {
          this.loadingStop();
          this.notifValidasi(post.data.message, true);
          return;
        }

        this.notifSuksesSimpan();
        this.$router.push("/warehouse/materialout/manual");
        this.loadingStop();
      } catch (error) {
        this.loadingStop();
        console.log(error);
        this.notifError("Hubungi INSYS");
      }
    },
  },
};
</script>

<style>
.tengah {
  text-align: center;
  color: rgb(115, 103, 240);
}
#container {
  position: relative;
  width: 600px;
  height: 400px;
}
</style>
<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css" />
